import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<path d=\"M22 17V8C22 6.34 20.66 5 19 5H5C3.34 5 2 6.34 2 8V17H0V19H2H22H24V17H22ZM4 17V8C4 7.45 4.45 7 5 7H19C19.55 7 20 7.45 20 8V17H4Z\" fill={{this.defaultColor}}></path>", {
  moduleName: "@dashboard/shared-ui/components/svgs/market/laptop.hbs"
});